import styled from '@emotion/styled';


export const GraphContainer = styled.div`
    width: 100%;
    height:100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end; /* push chart to bottom */
    flex-grow: 1; /* allow it to stretch inside parent */
    position: relative;
`;

export const GraphInner = styled.div`
    pointer-events: auto;
    height:100%;
    width: 100%;
    position: relative;
    flex: 1;
    margin-top: auto;

    canvas {
        width: 100% !important;
        height: 100% !important;
        display: block;
        background: transparent !important; /* no background */
        border: none !important;            /* no border */
        outline: none !important;
        min-height: 1px;
    }
`;
